<form [formGroup]="mainForm">
    <h1 mat-dialog-title>{{ 'COMPANY_EDIT_DIALOG.TITLE' | translate }}</h1>
    <div mat-dialog-content>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'COMPANY_EDIT_DIALOG.NAME_LABEL' | translate }}</mat-label>
            <input matInput formControlName="name" autocomplete="off" required>
            <mat-error msg></mat-error>
        </mat-form-field>

    </div>
    <div mat-dialog-actions class="flex-h flex-end">
      <button mat-flat-button color="primary" (click)="save()" type="submit">{{ 'GENERAL.OK' | translate }}</button>
      <button mat-flat-button color="accent" [mat-dialog-close]>{{ 'GENERAL.CANCEL' | translate }}</button>
    </div>
</form>
